import React, { useState, useEffect } from 'react'
import './footer.modern.css'

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

export default function ModernFooter() {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    fetch(`${API_URL}/site-settings`)
      .then(res => res.json())
      .then(data => setSettings(data))
      .catch(() => {});
  }, []);

  const socialLinks = [
    { key: 'social_facebook', icon: 'fab fa-facebook-f', label: 'Facebook' },
    { key: 'social_instagram', icon: 'fab fa-instagram', label: 'Instagram' },
    { key: 'social_tiktok', icon: 'fab fa-tiktok', label: 'TikTok' },
    { key: 'social_pinterest', icon: 'fab fa-pinterest-p', label: 'Pinterest' },
    { key: 'social_youtube', icon: 'fab fa-youtube', label: 'YouTube' },
  ];

  return (
    <footer className="modern-footer">
      <div className="footer-main">
        <div className="footer-container">
          <div className="footer-column">
            <div className="footer-brand">
              <img src="/images/logo.webp" alt="TC Nails Depot" className="footer-brand-logo" />
            </div>
            <p className="footer-description">
              Your trusted source for professional nail supplies. Serving salons and beauty professionals nationwide.
            </p>
            <div className="footer-social">
              {socialLinks.map(s => {
                const url = settings[s.key];
                if (!url) return null;
                return (
                  <a key={s.key} href={url} className="social-link" aria-label={s.label} target="_blank" rel="noopener noreferrer">
                    <i className={s.icon}></i>
                  </a>
                );
              })}
            </div>
          </div>

          <div className="footer-column">
            <h4>Shop</h4>
            <a href="/products">All Products</a>
            <a href="/products?filter=new">New Arrivals</a>
            <a href="/best-sellers">Best Sellers</a>
            <a href="/products?filter=sale">Sale</a>
            <a href="/products">Brands</a>
          </div>

          <div className="footer-column">
            <h4>Customer Service</h4>
            <a href="/about">About Us</a>
            <a href="/contact">Contact Us</a>
            <a href="/shipping">Shipping Info</a>
            <a href="/returns">Returns & Exchanges</a>
            <a href="/faq">FAQ</a>
          </div>

          <div className="footer-column">
            <h4>Account</h4>
            <a href="/login">Sign In</a>
            <a href="/signup">Create Account</a>
            <a href="/orders">Order History</a>
            <a href="/wishlist">Wishlist</a>
            <a href="/rewards">Rewards Program</a>
          </div>

          <div className="footer-column">
            <h4>Contact</h4>
            <div className="footer-contact-info">
              <p>
                <i className="fas fa-map-marker-alt"></i>
                {settings.store_address || '3359 W. Walnut St, Suite 200, Garland, TX 75042'}
              </p>
              <p>
                <i className="fas fa-phone"></i>
                {settings.store_phone || '972-487-1325 / 845-300-5559 / 845-480-2119'}
              </p>
              <p>
                <i className="fas fa-envelope"></i>
                {settings.store_email || 'ct1nailsdepot@gmail.com'}
              </p>
              <p>
                <i className="fas fa-clock"></i>
                {settings.store_hours || 'Sun-Fri: 9am - 7pm, Sat: By Appointment'}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="footer-copyright">
            © {new Date().getFullYear()} {settings.store_name || 'TC Nails Depot'}. All rights reserved.
          </p>
          <div className="footer-legal">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
            <a href="/accessibility">Accessibility</a>
          </div>
          <div className="footer-payment">
            <span className="payment-text">We Accept:</span>
            <i className="fab fa-cc-visa"></i>
            <i className="fab fa-cc-mastercard"></i>
            <i className="fab fa-cc-amex"></i>
            <i className="fab fa-cc-discover"></i>
            <i className="fab fa-cc-paypal"></i>
          </div>
        </div>
      </div>
    </footer>
  )
}
